import { CancelablePromise, OpenAPI, Response } from "@/api";
import { request as __request } from "@/api/core/request";
import { ToDeleteRequest } from "@/utils/slice";
import { ListRequest } from "@/api/models/ListRequest";
import { CategoryAddRequest } from "@/api/models/catrgory/CategoryAddRequest";
import { CategoryListResponse } from "@/api/models/catrgory/CategoryListResponse";
import { CategoryUpdateRequest } from "@/api/models/catrgory/CategoryUpdateRequest";

export class CategoryService {
  public static Add(body: CategoryAddRequest): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/admin/category",
      body: body,
    });
  }

  public static Delete(body: number): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admin/category",
      body: ToDeleteRequest(body),
    });
  }

  public static Drop(body: number): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admin/category/drop",
      body: ToDeleteRequest(body),
    });
  }

  public static Update(
    body: CategoryUpdateRequest
  ): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/admin/category",
      body: body,
    });
  }

  public static ListAll(
    body: ListRequest
  ): CancelablePromise<CategoryListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/category",
      body: body,
    });
  }
}
